import { render, staticRenderFns } from "./Knobs.vue?vue&type=template&id=c71d8a4e&"
import script from "./Knobs.vue?vue&type=script&lang=js&"
export * from "./Knobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports